import React from "react";
import GlobalStyles from "./GlobalStyles";
import Router from "./Router";
import Background from "./Background";

const App = () => {
  return (
    <>
      <GlobalStyles></GlobalStyles>
      <Background></Background>
      <Router></Router>
    </>
  );
};

export default App;
